export const BRAND_NAME = "Kyro";
export const COMPANY_NAME = "Kyro Solutions CO.L.L.C";
export const SITE_NAME =
  "Smarter Spaces - Computer Vision Based Intelligence from Kyro";
export const SITE_URL = "https://smarter-spaces.kyro.ae";

export const DEFAULT_LOGO = "/kyro-logo.png";
export const DEFAULT_LOGO_WHITE = "/kyro-logo-white.png";
export const DEFAULT_BROCHURE = "/kyro-smarter-spaces-brochure.pdf";
export const BROCHURE_FILENAME = "Kyro-Smarter-Spaces-Brochure.pdf";

export const CONTACT_EMAIL = "ask@kyro.ae";
export const CONTACT_PHONE = "+971503982545";
export const CONTACT_ADDRESS =
  "Prime Tower, Suite 2504, 39 Marasi Drive\nBusiness Bay, Dubai\nUnited Arab Emirates";
